import { css } from 'styled-components'
import { Font12 } from 'components/Typography'

export const HomeLicensesApplyCellStyles = css`
  padding: 24px 24px 24px 0;
`

export const CellStyles = css`
  ${Font12};
`
